module.exports = __webpack_public_path__ + "static/media/consumer-power-tablet.d46c5b19.jpg";